import moment from 'moment'

class Formatter {
  doFormat(value, format) {
    if (format.type === 'date') {
      return this._dateFormatter(value, format.format)
    }

    // drop through for no matching handler
    return value
  }

  _dateFormatter(date, format) {
    return moment(date).format(format)
  }
}

export default Formatter
